import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Holerites from '../../../components/rh/funcionarios/listar/holerites';


function HolFuncionariosScreen () {
    return (
        <Fragment>
            <Head titulo="Holerites de Funcionários | Consórcio LVF" />
            <Header />
            <Holerites />
            <Footer />
        </Fragment>
    );
}

export default HolFuncionariosScreen;